import { apiGet, apiPost, apiPatch, apiDelete, ApiError } from '../../Dataman';
import { DEALS_PATHS } from './deals_paths';
import { createRequestBodyAdapter } from './adapters';
import Backend from 'App/Dataman-Backend';
import { isEmpty } from '@/components/filters/Utils';
import { syncStaffCommentFiles } from '@/app/services/orders/staffCommentFiles';

const { apiUrlSuffix } = Backend.config;

export const dealsAPiAdapter = {
  getProductOrders: (params) => apiGet(DEALS_PATHS.deals + apiUrlSuffix, { params }),
  getProductOrder: (id, params) => apiGet(`${DEALS_PATHS.deals}/${id}`, { params }),
  createProductOrder: async (data) => {
    const { staffCommentFilesChanges } = data || {};
    let preparedData = { ...createRequestBodyAdapter(data) };
    delete preparedData.trackingInformation;
    const response = await apiPost(DEALS_PATHS.deals, { data: preparedData });
    await syncStaffCommentFiles(response?.data?.id, staffCommentFilesChanges);
    return response;
  },
  updateProductOrderInformation: async (id, data) => {
    const { staffCommentFilesChanges } = data || {};
    let preparedData = { ...data };
    delete preparedData.staffCommentFilesChanges;
    preparedData = updateDealAdapter(preparedData);
    delete preparedData.trackingInformation;
    const response = await apiPatch(`${DEALS_PATHS.deals}/${id}`, { data: preparedData });
    await syncStaffCommentFiles(id, staffCommentFilesChanges);
    return response;
  },
  deleteProductOrder: (id) => apiDelete(`${DEALS_PATHS.deals}/${id}`),
  generateOrdersReport: async (data) => {
    const res = await apiPost(DEALS_PATHS.report, { data, responseType: 'blob' });
    if (res.status === 201) {
      const { data, headers } = res;
      return {
        file: data,
        contentType: headers['content-type'],
        size: headers['content-length'],
        fileName: (headers['content-disposition'] || '').match(/(?<=filename=").*(?=")/)?.[0],
      };
    } else {
      throw new ApiError('Error', res);
    }
  },
  getDealTypes: (params) => apiGet(DEALS_PATHS.deal_types + apiUrlSuffix, { params }),
  getDealType: (id) => apiGet(`${DEALS_PATHS.deal_types}/${id}`),
  createDealType: (data) => apiPost(DEALS_PATHS.deal_types, { data }),
  updateDealType: (id, data) =>
    apiPatch(`${DEALS_PATHS.deal_types}/${id}`, {
      data,
    }),
  deleteDealType: (id) => apiDelete(`${DEALS_PATHS.deal_types}/${id}`),

  getContactTypes: (params) => apiGet(DEALS_PATHS.contactTypes, { params }),
  getDealItems: (params) => apiGet(DEALS_PATHS.items + apiUrlSuffix, { params }),
  getDealItem: (id, params) => apiGet(`${DEALS_PATHS.items}/${id}`, { params }),
  createDealItem: (data) => apiPost(DEALS_PATHS.items, { data }),
  updateDealItem: (id, data) =>
    apiPatch(`${DEALS_PATHS.items}/${id}`, {
      data,
    }),
  deleteDealItem: (id) => apiDelete(`${DEALS_PATHS.items}/${id}`),

  getOrderHistory: (id, params) => apiGet(`${DEALS_PATHS.deals}/${id}/history`, { params }),
  getOrderSnapshotById: (id, snapshot_id) => apiGet(`${DEALS_PATHS.deals}/${id}/history/snapshots/${snapshot_id}`),
};

function updateDealAdapter(requestBody) {
  const { billing_informations, dealItems, ...rest } = requestBody;
  const data = { ...rest };
  if ('dealItems' in requestBody) {
    data.dealItems =
      dealItems?.map((dealItem) => {
        const res = {
          name: dealItem?.item?.name || dealItem?.name,
          quantity: dealItem.quantity,
        };

        if (dealItem?.item?.wimsId || dealItem?.wimsId) {
          res.wimsId = dealItem?.item?.wimsId || dealItem?.wimsId;
        }

        if (dealItem?.item?.wimsModule || dealItem?.wimsModule) {
          res.wimsModule = dealItem?.item?.wimsModule || dealItem?.wimsModule;
        }

        return res;
      }) || [];
  }

  if (!isEmpty(billing_informations)) {
    data.billing_informations = billing_informations;
  }
  return data;
}
